import { ModalMonthComponent } from '@components/calendar/modal-month/modal-month.component';
import { Component, OnInit, TrackByFunction, Input, Output, HostListener, OnDestroy, EventEmitter, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { DayData, ImputationsData } from './calendar-day/calendar-day.model';
import { CalendarService } from './calendar.service';
import { ModalDayComponent } from './modal-day/modal-day.component';
import { ModalWeekComponent } from './modal-week/modal-week.component';
import { ObservatoryService, StorageService } from '@services/services.module';
import { NotificationsService } from '@services/notifications/notifications.service';
import { Subscription, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: [CalendarService]
})

export class CalendarComponent implements OnInit, OnDestroy, OnChanges {

  @Input() date;
  @Output() passDate: EventEmitter<any> = new EventEmitter();
  @HostListener('openDay')
  private subscriptions: Array<Subscription> = [];
  public dayList: DayData[];
  public columns: 7;
  public year: Date;
  public month: Date;
  public weeksCalendar;
  public userId: string;
  public selectDay: Date;
  public day;
  public diaData: DayData;
  public recoverDay: any;
  public sumProjectsS1: number;
  public sumProjectsS2: number;
  public sumProjectsS3: number;
  public userData: any;
  public initDate: any;
  public currentDate: any;
  public dateYear: any;
  public dateMonth: any;
  public dateMonthEnd: any;
  public nextMonthCounter: number;
  public monthCounter: number;
  public previousMonthCounter: number;
  currentDay: string;
  @Input() enableExpress;
  @Input() employee;
  @Input() desbloq;
  managingEmployee;
  // Modal mensual:
  monthlyImputationData: any;
  projectIdToMonthImputation: string;
  sapIdToMonthImputation: string;
  dayListToMonth: Array<DayData>;

  dayNames = [
    this.translate.instant('DIAS.LUNES'),
    this.translate.instant('DIAS.MARTES'),
    this.translate.instant('DIAS.MIERCOLES'),
    this.translate.instant('DIAS.JUEVES'),
    this.translate.instant('DIAS.VIERNES'),
    this.translate.instant('DIAS.SABADO'),
    this.translate.instant('DIAS.DOMINGO')
  ];
  selected = '1';

  monthNames = [
    this.translate.instant('MES.ENERO'),
    this.translate.instant('MES.FEBERO'),
    this.translate.instant('MES.MARZO'),
    this.translate.instant('MES.ABRIL'),
    this.translate.instant('MES.MAYO'),
    this.translate.instant('MES.JUNIO'),
    this.translate.instant('MES.JULIO'),
    this.translate.instant('MES.AGOSTO'),
    this.translate.instant('MES.SEPTIEMBRE'),
    this.translate.instant('MES.OCTUBRE'),
    this.translate.instant('MES.NOVIEMBRE'),
    this.translate.instant('MES.DICIEMBRE')
  ];

  monthString: string;
  YearString: any;

  constructor(
    public _calendarService: CalendarService,
    public _observatoryService: ObservatoryService,
    private notification: NotificationsService,
    private storage: StorageService,
    private modalService: NgbModal,
    public translate: TranslateService
  ) {
    window.scrollTo(0, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const employee: SimpleChange = changes.employee;
    if (employee) {
    this.employee = employee.currentValue;
    }
    if (!this.employee && this.initDate) {
      this.generateCalendar(this.employee);
    }
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit(): void {
    this.monthCounter = 1;
    this.userData = this.storage.get('userDataStorage');
    this.initDate = new Date();
    this.currentDate = this.initDate;
    this.dateYear = new Date().getFullYear();
    this.dateMonth = new Date().getMonth();
    const newMonth = this.dateMonth + 1;
    const str = '' + newMonth;
    const pad = '00';
    this.dateMonthEnd = pad.substring(0, pad.length - str.length) + str;
    this._observatoryService.setData('dateMonthEnd', this.dateMonthEnd);

    this.generateCalendar(this.userData.employeeNumber);
    this.monthlyImputationData = [];
    if (this.desbloq) {
      this._observatoryService.getData('changeEmployee').subscribe(val => {
        if (val) {
          this.managingEmployee = val.Id;
          if (val.Id !== 0) {
            this.generateCalendar(val.Id);
          } else {
            this.enableExpress = false;
            this.generateCalendar(this.userData.employeeNumber);
          }
        }
      });
    }
    this.changeMonth(this.initDate);

    this.subscriptions.push(
      // actualizar el calendario
      this._observatoryService.getData('updateCalendar').subscribe(val => {
        if (val) {
          this.generateCalendar(this.managingEmployee);
          this._observatoryService.setData('updateCalendar', false);
        }
      })
    );

  }

  addZeroToMonth(month: string): string {
    if (month.length === 1) {
      return '0' + month;
    }
    return month;
  }

  generateCalendar(employee): void {
    if (employee === 0 || employee === '' || employee === undefined ) {
      employee = this.userData.employeeNumber;
    }
    this.setCalendarYearDate(employee);
    const date = new Date();
    const month = this.addZeroToMonth((date.getMonth() + 1).toString());
    this.currentDay = date.getFullYear().toString() + month + date.getDate().toString();
    if (!this.userData) {
      return;
    }

    this.subscriptions.push(
      this._calendarService
        .getCalendar(
          employee,
          this.dateYear,
          this.dateMonthEnd
        )
        .subscribe(val => {
          this.dayList = val;
          this.storage.set('dayListToMonth', val);
          this._observatoryService.setData('dayListToMonth', val);
          this.dayListToMonth = val;
          const list = val.filter(x => x.locked === 'T');
          if (list.length === 0) {
            this.storage.set('subtractMonth', true);
          }
          // divide array  35 in  5 rows
          const weeks = [];
          while (this.dayList.length > 0) {
            weeks.push(this.dayList.splice(0, 7));
          }

          // For a empty calendar:
          // this.empleado === 0
          if (this.desbloq) {

            if (!this.employee) {

              weeks.forEach(element => {
                element.map(function (item) {
                  item.employeeId = 0;
                  item.imputations = [];
                  item.locked = 'F';
                  return item;
                });
              });
            } else {
              this.enableExpress = true;
              weeks.forEach(element => {
                element.map(function (item) {
                  item.employeeId = employee;
                  item.locked = 'F';
                  return item;
                });
              });
            }
          }

          this.weeksCalendar = weeks;
          const firstDateMonthImput = this.year + this.dateMonthEnd + '01';
          // tslint:disable-next-line:radix
          const lastDayFormat = new Date(this.initDate.getFullYear(), parseInt(this.dateMonthEnd), 0);
          const lastDateMonthImput = this.initDate.getFullYear() + this.dateMonthEnd + lastDayFormat.getDate().toString();

          this.weeksCalendar.forEach(element => {
            const lac = element.find(x => x.date ===  lastDateMonthImput);
            if (lac) {
              if (lac.locked === 'T') {
                this.enableExpress = false;
              } else {
                this.enableExpress = true;
              }
            }
          });
        })
    );

  }

  refreshCalendar() {
    this.generateCalendar(this.managingEmployee);
  }

  setCalendarYearDate(employee): void {
    //  data --> fecha inicial, fecha final, idempleado --> observable para que
    // resumen inputaciones pueda actualizar.
    const firstDayFormat = new Date(this.initDate.getFullYear(), this.initDate.getMonth(), 1);
    // tslint:disable-next-line:radix
    const lastDayFormat = new Date(this.initDate.getFullYear(), parseInt(this.dateMonthEnd), 0);
    const firstDay = '0' + firstDayFormat.getDate().toString();
    const lastDay = lastDayFormat.getDate().toString();
    const data = {
        initDate:  String(this.currentDate.getFullYear() + this.dateMonthEnd + firstDay),
        endDate: String(this.currentDate.getFullYear() + this.dateMonthEnd + lastDay),
        employeeId: String(employee)
    };

      this._observatoryService.setData('CalendarYearDate', data);
  }

  nextMonth() {
    const primer = new Date(
      this.initDate.getFullYear(),
      this.initDate.getMonth() + this.monthCounter,
      1
    );
    this.currentDate = primer;
    this.monthCounter = this.monthCounter + 1;
    this.changeMonth(primer);
    this.dateYear = primer.getFullYear();
    const monthChange = primer.getMonth() + 1;
    const str = '' + monthChange;
    const pad = '00';

    this.dateMonthEnd = pad.substring(0, pad.length - str.length) + str;
    this._observatoryService.setData('dateMonthEnd', this.dateMonthEnd);

    this.generateCalendar(this.managingEmployee);
  }

  previousMonth() {
    this.monthCounter = this.monthCounter - 1;
    const primer = new Date(
      this.initDate.getFullYear(),
      this.initDate.getMonth() + this.monthCounter,
      0
    );
    this.currentDate = primer;
    this.changeMonth(primer);
    this.dateYear = primer.getFullYear();
    const monthChange = primer.getMonth() + 1;
    const str = '' + monthChange;
    const pad = '00';
    this.dateMonthEnd = pad.substring(0, pad.length - str.length) + str;
    this._observatoryService.setData('dateMonthEnd', this.dateMonthEnd);
    this.generateCalendar(this.managingEmployee);
  }

  openDay(data) {
    const ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false
    };
    this._observatoryService.setData('inputDayData', data);
    const modalRef = this.modalService.open(ModalDayComponent, ngbModalOptions);
    // modalRef.componentInstance.data = data;

    modalRef.componentInstance.update.subscribe(() => {
      this.generateCalendar(this.managingEmployee);
    });
  }

  openExpressInputation() {
    const ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false
    };
    this.generateCalendar(this.managingEmployee);
    const modalRef = this.modalService.open(ModalMonthComponent, ngbModalOptions);
    modalRef.componentInstance.monthString = this.monthString;
    modalRef.componentInstance.YearString = this.YearString;

    modalRef.componentInstance.update.subscribe(() => {
      this.generateCalendar(this.managingEmployee);
    });
  }

  openWeek(data) {
    this._observatoryService.setData('inputWeekData', data);
    this.modalService.open(ModalWeekComponent);
  }

  changeMonth(initDate) {
    this.monthString = this.translate.instant(this.monthNames[initDate.getMonth()]);
    this.YearString = initDate.getFullYear();
  }

  prepareDataToImputMonth(event: MouseEvent): void {
    event.srcElement.setAttribute('disabled', '');
    setTimeout(() => {
      event.srcElement.removeAttribute('disabled');
    }, 1500);
    this.dayListToMonth = this.storage.get('dayListToMonth');
    // Elimino días con locked === 'T' || festive === 'T'
    for (const i in this.dayListToMonth) {
      if (this.dayListToMonth[i].locked === 'F' && this.dayListToMonth[i].festive === 'F'
        && this.dayListToMonth[i].imputations.length < 1 && this.getMonth(this.dayListToMonth[i].date) === this.dateMonthEnd) {
        this.monthlyImputationData.push(this.dayListToMonth[i]);
      }
    }

    // Asigno horas al workingDay y activityTipe siempre S1
    for (let i = 0; i < this.monthlyImputationData.length; i++) {
      if (this.monthlyImputationData[i].imputations.length < 1) {
        this.monthlyImputationData[i].imputations[0] = {};
        this.monthlyImputationData[i].imputations[0].activityTypeId = '1';
        this.monthlyImputationData[i].imputations[0].hours = this.monthlyImputationData[i].workingDay;
        this.monthlyImputationData[i].imputations[0].projectId = this.projectIdToMonthImputation;
        this.monthlyImputationData[i].imputations[0].sapId = this.sapIdToMonthImputation;
      }
    }

    if (this.monthlyImputationData.length === 0) {
      this.notification.setWarning(this.translate.instant('CALENDARIO.ERROR_IMPUTAR_MES'));
      return;
    }

    this.subscriptions.push(
      this._calendarService.saveMonth(this.monthlyImputationData).subscribe((data) => {
        if (data.response === 'OK') {
          this.modalService.dismissAll();
          this.monthlyImputationData = [];
          this.notification.setSuccess(this.translate.instant('CALENDARIO.EXITOMENSAJE'));
          this.refreshCalendar();
        } else {
          this.notification.setWarning(this.translate.instant('CALENDARIO.ADVMENSAJE'));
        }
      })
    );
  }

  insertProject(projectData): void {
    this.projectIdToMonthImputation = projectData.Id;
    this.sapIdToMonthImputation = projectData.name;
  }

  private getMonth(fecha): string {
    return fecha.substring(4, 6);
  }

  hoursPerWeek (week) {
    let total = 0;
    week.forEach(element => {
      element.imputations.forEach(element => {
        if (element.activityTypeId === '1') {
          total = total + Number(element.hours);
        }
      });
    });

    return total;
  }

  /**
   * @name ngOnDestroy
   * @description Lifecycle hook
   */
  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }
}
